import {
  Tooltip,
  Group,
  Text,
  ActionIcon,
  Badge,
  Stack,
  Flex,
} from "@mantine/core"
import { IconPencil } from "@tabler/icons-react"
import { API_URL } from "shared/config"
import { Link } from "react-router-dom"
import { Image } from "../../shared/ui/Image"
import { PATHS } from "../../shared/lib/paths"
import { observer } from "mobx-react-lite"
import { type ScheduleEvent } from "../../shared/types/scheduleEvent"
import { fDate } from "../../shared/lib/dates"
import { ScheduleRemoveModal } from "../../features/schedule"

// ----------------------------------------------------------------------

export const ScheduleTableRow = observer(function ScheduleTableRow(scheduleEvent: ScheduleEvent) {
  const { title, _id, isOnline, level, instructor, profession, date } = scheduleEvent

  return (
    <tr>
      <td>
        <Flex gap="xl">
          <Stack spacing="sm">
            <Text fz="xl" fw={600}>
              {title}
            </Text>
            {level && <Text>
              {level === "based" ? "Базовый" : "Продвинутый"} уровень
            </Text>}
          </Stack>
        </Flex>
      </td>
      <td>
        <Flex gap="md" align="center">
          {instructor && (
            <Image
              src={`${API_URL}/media/${instructor.avatar}`}
              ratio="1/1"
              sx={{ maxWidth: 48, minWidth: 48, borderRadius: "50%" }}
            />
          )}
          <Text fz="md" color={instructor ? undefined : "red"}>
            {instructor ? instructor.name : "Не назначен"}
          </Text>
        </Flex>
      </td>
      <td>
        <Text fz="md">
          {fDate(date, "D MMMM")}
        </Text>
      </td>
      <td>
        <Badge color={isOnline ? "green" : "orange"} fullWidth>
          {isOnline ? "Да" : "Нет"}
        </Badge>
      </td>
      <td>
        <Badge color={profession ? "green" : "red"} fullWidth>
          {profession ? "Да" : "Нет"}
        </Badge>
      </td>
      <td>
        <Group position="right" noWrap>
          <Tooltip label="Редактировать">
            <ActionIcon radius="xl" size="xl" component={Link} to={PATHS.DASHBOARD.SCHEDULE.EDIT(_id)}>
              <IconPencil stroke={1.5}/>
            </ActionIcon>
          </Tooltip>
          <ScheduleRemoveModal {...scheduleEvent} />
        </Group>
      </td>
    </tr>
  )
})
